import styled from 'styled-components';

export const CartProductSection = styled.section`
  display: flex;
  justify-content: space-between;
  padding: ${(props) =>
    props.paymentPage ? '12px 0px 12px 0px' : '12px 0px 12px 10px'};
  background-color: ${(props) =>
    props.backgroundColor == true ? '#63b0a814' : '#FFFFFF'};

  .product_image {
    width: 68px;
    height: 68px;
    border-radius: 4px;
  }
  &.lowOpac {
    opacity: 0.4;
  }
`;

export const ItemDetail = styled.div`
  padding-left: 18px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 6px;

  .product_name {
    font-size: clamp(12px, 2vw, 14px);
    font-weight: 500;
    color: hsl(0deg, 0%, 0%, 87%);
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .pack_of_item {
    color: rgba(168, 168, 168, 0.8);
    font-size: 11px;
    padding: 8px 0 2px;
  }
  .discount_message {
    font-size: 12px;
    color: #63b0a8;
    font-weight: 500;
    padding: 0px 0px 10px;
  }
  .product_description {
    font-size: 10px;
    color: #000000;
    font-weight: 500;
    opacity: 0.54;
  }
  .size_of_item {
    font-size: 10px;
    opacity: 0.5;
    font-weight: 500;
    line-height: 13px;
  }
  .addForFreeBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ef4e5e;
    gap: 5px;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 5px 5px;
    cursor: pointer;
    font-size: 11px;
    width: 120px;
    font-weight: 500;

    &:hover {
      background-color: darken(#63b0a8, 10%);
    }

    span {
      font-size: 16px;
    }
  }
`;

export const AddDeleteItem = styled.div`
  width: ${(props) => (props.showCartFillerStrip ? '34px' : '106px')};
  height: 32px;
  background-color: hsl(0deg, 0%, 0%, 4%);
  display: flex;
  align-items: center;

  .disabled {
    opacity: 0.3;
  }

  .common_button {
    height: 32px;
    flex-grow: 1;
    flex-basis: 33.33%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .total_items {
    background: #fff;
    border: 0.5px solid rgb(0 0 0 / 46%);
    font-size: 14px;
    font-weight: 500;
    color: hsl(0deg 0% 0% / 87%);
  }

  .plusMinusImage {
    width: 100%;
    height: auto;
  }

  .plus_items,
  .delete_items {
    position: relative;
    @media (min-width: 720px) {
      cursor: pointer;
    }
    &:hover {
      background-color: #dfdfdf80;
      @media (max-width: 720px) {
        background-color: transparent;
      }
    }
  }
  .flexImg {
    display: flex;
    align-items: center;
    img {
      padding: 6px;
    }
  }
  .sizeBtn {
    font-family: 'Montserrat';
    font-size: 12px;
    width: 100px;
    padding: 7px;
    font-weight: 500;
    background: white;
    border: 1px solid rgba(0, 0, 0, 0.4);
  }
`;

export const TotalPriceInCart = styled.p`
  font-size: clamp(14px, 2vw, 16px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  padding-right: 10px;
  display: flex;
  column-gap: 4px;
  align-items: center;

  .freeText {
    font-size: 16px;
    color: #000000;
    font-weight: 600;
    opacity: 0.7;
  }
`;

export const SpinnerLoader = styled.div`
  display: block;
  position: relative;
  letter-spacing: 0.5px;

  .spinner::after {
    content: '';
    box-sizing: border-box;
    width: 18px;
    height: 18px;
    position: absolute;
    top: calc(50% - 8px);
    left: calc(50% - 8px);
    border-radius: 50%;
  }

  .spinner.smooth::after {
    border-top: 2px solid hsl(0deg, 0%, 0%, 87%);
    border-left: 2px solid hsl(0deg, 0%, 0%, 87%);
    border-right: 2px solid rgba(255, 255, 255, 0);
    animation: spinner 1.4s linear infinite;
  }

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ProductImageSection = styled.div`
  position: relative;

  img {
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }
`;

export const FreeTag = styled.img`
  position: absolute;
  left: 0;
  top: 0;
`;
export const PageLoadingText = styled.div`
  font-size: 14px;
  text-align: center;
  padding-top: 60px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
`;

export const EmptyCartImage = styled.img`
  width: 100%;
  height: auto;
`;

export const SpecialOfferStrip = styled.span`
  display: inline-block;
  background-color: #fdf1d8;
  font-size: 10px;
  font-weight: 500;
  padding: 3px 6px;
  color: #727272;
  margin-bottom: 4px;
  width: fit-content;
`;

export const CartFillerStrikePrice = styled.span`
  text-decoration: line-through;
  font-size: 14px;
  font-weight: 5;
  color: rgb(45 45 45 / 64%);
  margin-right: 8px;
`;

export const CartDiscountPercentage = styled.span`
  font-size: clamp(11px, 2vw, 12px);
  font-weight: 600;
  color: #63b0a8;
`;

export const CartButton = styled.div`
  display: flex;
  justify-content: space-between;
`;
